import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { GreenMarker } from '../GreenMarker/GreenMarker';
import './TextLink.pcss';

type Props = {
  className?: string;
  children: ReactNode;
  count?: number;
  icon?: JSX.Element;
  onClick?: () => void;
  sm?: boolean;
  showGreenMarker?: boolean;
  showNewLabel?: boolean;
};

export const TextLink = ({
  className,
  children,
  count,
  icon,
  onClick = () => {},
  sm,
  showGreenMarker,
  showNewLabel,
}: Props) => {
  return (
    <div
      className={classNames(className, 'text-link', {
        'text-link--with-icon': icon,
        'text-link--sm': sm,
      })}
      onClick={onClick}
    >
      {icon && <span className="text-link__icon">{icon}</span>}
      <span className="text-link--children">
        {children}
        {!!count && (
          <span className="text-link__count">
            <span>&nbsp;</span>(
            <span className="text-link__count-number">{count}</span>)
          </span>
        )}
        {showNewLabel && <div className="text-link__new-label">New</div>}
        {showGreenMarker && <GreenMarker className="text-link__green-marker" />}
      </span>
    </div>
  );
};
